import { useEffect, useState } from 'react';
import { HelpIcon, Tooltip, LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import { t } from '@lingui/core/macro';
import { isEqual } from 'lodash';

function RtdMapping({value, item, error, onChange=() => {}}) {
  const [currentValue, setCurrentValue] = useState(value?.requestedValue || value?.value || []);
  const [requested, setRequested] = useState(value.requestedValue && !isEqual(value.requestedValue, value.value));
  const requestedTooltipText = t`
    This value has been requested. <br />
    The current value is <strong>${value?.value}</strong> set on:
    ${new Date(value?.lastUpdatedDate).toLocaleString()}.
  `;

  useEffect(() => {
    const newRequested = value.requestedValue && !isEqual(value.requestedValue, value.value);
    setRequested(newRequested);
  }, [value]);

  function handleChange(value) {
    setRequested(false);
    setCurrentValue(value);
    onChange(value);
  }

  return (<>
    <label htmlFor={item.key} className={item.isRemoteSetting ? 'remote-control' : ''}>
      <span
        data-tooltip-html={requested ?
          requestedTooltipText : ''
        }
        data-tooltip-id={`control-tooltip-${item.key}`}
      >
        {item.displayName}
        { item.description ? <HelpIcon text={item.description} /> : <></> }
        &nbsp;<LoadingIndicator
          show={requested}
        />
      </span>

    </label>
    <div className="input-group">
      {item.options.map(option => (
        <label key={option.value}>
          <input
            type="checkbox"
            checked={currentValue?.includes(option.value)}
            onChange={() => {
              const newValue = currentValue.includes(option.value)
                ? currentValue.filter(id => id !== option.value)
                : [...currentValue, option.value];
              handleChange(newValue);
            }}
          />
          {option.displayName}
        </label>
      ))}
    </div>
    {error ?
      <p className="error-text">{error}</p>
    : null}

    <Tooltip id={`control-tooltip-${item.key}`} place="right" />
  </>);
}

export default RtdMapping;